var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.7855 0.765047L74.4577 0.000696896C74.4577 0.000696896 65.0734 -0.155924 59.1843 4.22676C52.5161 9.18913 50.0067 15.5149 43.1882 19.482C36.3696 23.4492 29.1641 24.1776 29.1641 24.1776V62.4084L75.7855 0.765047Z",
    fill: "#B39100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5126 4.99238C53.8444 9.95495 51.335 16.2805 44.5164 20.2477C37.6977 24.2148 30.4922 24.9432 30.4922 24.9432V63.174C30.4922 63.174 37.6977 62.4456 44.5164 58.4785C51.335 54.5113 53.8442 48.1858 60.5126 43.2232C66.4015 38.8405 75.786 38.9971 75.786 38.9971V0.766322C75.7859 0.766322 66.4015 0.609701 60.5126 4.99238Z",
    fill: "#FFD001"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5828 22.8516L23.2109 23.6385V96.9403L23.2127 96.9401C23.2169 97.4912 23.5501 98.0171 24.2315 98.4104C25.7453 99.2844 28.3895 99.1748 30.1373 98.1656C31.106 97.6064 31.594 96.8883 31.5807 96.2102L31.5828 96.21V22.8516Z",
    fill: "#C2CDDD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1387 24.8122C31.8866 23.8031 32.0765 22.2765 30.5627 21.4025C29.0489 20.5285 26.4047 20.6382 24.6569 21.6473C22.909 22.6565 22.7191 24.183 24.2329 25.057C25.7467 25.931 28.3907 25.8214 30.1387 24.8122Z",
    fill: "#667790"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5284 44.8974L42.5469 26.9961L48.889 24.1684C50.5939 23.4082 52.2983 23.0366 54.0022 23.0535C55.6985 23.0534 57.2732 23.5368 58.7261 24.5035C60.1961 25.4627 61.3758 26.9397 62.2652 28.9344C63.1545 30.9291 63.4647 32.7937 63.1958 34.5282C62.9438 36.2552 62.2548 37.758 61.1286 39.0368C59.9948 40.2985 58.5754 41.3095 56.8706 42.0696L50.5284 44.8974ZM54.6004 38.4219C56.1518 37.7302 57.2557 36.768 57.9119 35.5352C58.5681 34.3025 58.4933 32.7825 57.6876 30.9754C56.8818 29.1682 55.8012 28.0967 54.4456 27.761C53.0901 27.4252 51.6366 27.6032 50.0851 28.2949L48.832 28.8536L53.3473 38.9806L54.6004 38.4219Z",
    fill: "#1C1E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD);
export default __webpack_public_path__ + "static/media/d.ef1d7981bc9595c419cd4ffc842090c4.svg";
export { ForwardRef as ReactComponent };